"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getConfig_1 = require("./getConfig");
var FETCH_CONFIG_QUERY_COMMERCIAL = "\n  query getConfigCommericial($appId: AppId!) {\n    experience(appId: $appId) {\n      config {\n        commercial {\n          sessionResetSchedule\n          enableChromecast\n        }\n        " + getConfig_1.CONFIG + "\n      }\n    }\n  }\n";
exports.default = FETCH_CONFIG_QUERY_COMMERCIAL;
//# sourceMappingURL=getConfigCommercial.js.map